import { Typography } from "@mui/material";
import { useTranslate } from "@/hooks";
import { IBreakOrEndProps } from "./BreakOrEnd.props";

const BreakOrEnd = ({ selectExtendedAction }: IBreakOrEndProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Typography sx={{ fontSize: 11, m: "auto 0", width: "100%", textAlign: "left", fontStyle: "italic", whiteSpace: "pre-line", maxWidth: "500px", lineHeight: 1.2 }}>
			{translate(selectExtendedAction === "break" ? "title_actionBreak" : "title_actionEnd")}
		</Typography>
	);
};

export default BreakOrEnd;
